import { ClientSupportPageContextValue } from "./ClientSupportPageContext";
import { useClientSupportPageContext } from "./useClientSupportPageContext";

export const useClientSupportPageWithSelectedConversation = (): Omit<
  ClientSupportPageContextValue,
  "selectedConversation"
> & {
  selectedConversation: NonNullable<
    ClientSupportPageContextValue["selectedConversation"]
  >;
} => {
  const context = useClientSupportPageContext();

  if (!context.selectedConversation) {
    throw new Error("No conversation selected");
  }

  return {
    ...context,
    selectedConversation: context.selectedConversation,
  };
};
